<template>
  <div class=" iqos-no-border iqos iqos-long p-0">
    <div class="cafe-card-container">
      <div class="cafe-card-left">
        <div class="cafe-card-general">
          <div class="card-image">
            <img
              :src="editing ? edit_fields.image : cafe.image"
              :class="editing ? 'cafe-image blur' : 'cafe-image'"
              v-if="cafe.image || edit_fields.image"
            />
            <img
              src="/icons/cafe-placeholder.jpg"
              alt
              class="cafe-image-placeholder"
              v-if="!cafe.image && !edit_fields.image"
            />
            <ImageUploader
              class="cafe-image-uploader"
              @success="onImageChange"
              v-if="editing"
              is_cafe
            />
          </div>

          <div class="general-info" v-if="!editing">
            <h2 class="info-name mb-15">{{ cafe.name }}</h2>
            <div class="info-text-line " v-if="cafe.address">
              <img src="/icons/addres-pointer-icon.svg" alt="" /><span
                class="address c-grey text-one-line"
                >{{ $t("general.cafe.address") }} {{ cafe.address }}</span
              >
            </div>
            <div class="info-text-line" v-if="todaySchedule">
              <img src="/icons/clock-icon.svg" alt="" /><span
                class="address c-grey"
              >
                {{ todaySchedule }}</span
              >
            </div>
            <div class="text-line mb-15">
              {{ $t("general.cafe.menu") }}:
              <a class="text-one-line" :href="onlineMenuLink" target="_blank"
                >https://cafe.qrwaiter.com.ua/{{ cafe.online_menu_link }}</a
              >
            </div>
            <div class="text-line">
              ID: <span>{{ cafe.qId }}</span>
            </div>
            <div class="text-line text-one-line">
              {{ $t("general.cafe.panel") }}
              <a
                class="mt-15 "
                :href="`https://queue.qrwaiter.com.ua/login/${cafe.qId}`"
                target="_blank"
                >https://queue.qrwaiter.com.ua/login/{{ cafe.qId }}</a
              >
            </div>

            <!-- <h4 class="info-description c-grey" v-if="!cafe.description"> {{ $t('general.cafe.about') }}</h4> -->
            <!-- <h4 class="info-description" v-if="cafe.description">{{ cafe.description }}</h4> -->
            <!-- <span class="info-field"
              >{{ $t("general.cafe.address") }} {{ cafe.address }}</span
            > -->
            <!-- <span class="info-field">Телефон: {{ cafe.contact_phone }}</span> -->
            <!-- <span class="info-field" v-if="cafe.price_level"
              >{{ $t("general.cafe.price_policy") }}
              {{ cafe.price_level }}</span
            > -->

            <!-- <a :href="onlineMenuLink" target="_blank" v-if="!editing && shouldShowMenuLink">cafe.qrwaiter.com.ua/{{cafe.online_menu_link}}</a> -->
            <a href="#" v-if="editing">cafe.qrwaiter.com.ua/</a>
            <input
              type="text"
              class="cafe-title-link cafe-link-input"
              v-model="edit_fields.online_menu_link"
              v-if="editing"
            />
            <p class="link-details c-grey" v-if="editing">
              Вкажіть посилання, за яким можна буде знайти Ваше онлайн-меню.
              Також Ви можете використовувати це посилання у Ваших соц. мережах.
              Посилання може містити малі літери латинського алфавіту, цифри і
              підкреслення (_).
            </p>
          </div>

          <div class="general-info" v-if="editing">
            <h2 class="info-name lh-0">
              <input
                type="text"
                maxlength="48"
                class="cafe-property-input f-input mt-0"
                placeholder="My Cafe"
                v-model="edit_fields.name"
              />
            </h2>
            <h4 class="info-description pt-0">
              <input
                type="text"
                maxlength="48"
                class="cafe-property-input"
                placeholder="Best cafe in the world"
                v-model="edit_fields.description"
              />
            </h4>
            <span class="info-field pt-0">
              <input
                type="text"
                maxlength="256"
                class="cafe-property-input small-input"
                id="gmapAddressField"
              />
            </span>
            <span class="info-field pt-0">
              <input
                type="text"
                maxlength="14"
                class="cafe-property-input small-input"
                placeholder="+38 050 12 34 456"
                v-model="edit_fields.contact_phone"
              />
            </span>
            <span class="info-field pt-0">
              <select v-model="edit_fields.price_level">
                <option :value="null" disabled>Цінова політика</option>
                <option value="$">$</option>
                <option value="$$">$$</option>
                <option value="$$$">$$$</option>
                <option value="$$$$">$$$$</option>
              </select>
            </span>
            <!-- <span class="info-field pt-0">
              <textarea
                type="text"
                maxlength="512"
                class="cafe-property-input small-input"
                placeholder="Ключові слова пошуку"
                v-model="edit_fields.keywords"
              ></textarea>
            </span> -->
          </div>

          <!-- <div class="cafe-edit w-min" v-if="editing">
            <img src="/icons/save.svg" @click="onEditFinish" />
          </div>

          <div class="cafe-edit" v-if="!editing" @click="showEditUI">
            <img src="/icons/edit.svg" />
          </div> -->
        </div>

        <div class="cafe-card-links c-white" v-if="false">
          <h4 class="queue-link cafe-card-link m-0">
            {{ $t("general.cafe.panelid") }}
            <span class="queue-id">{{ cafe.qId }}</span>
          </h4>
          <h4 class="cafe-card-link mt-15">
            {{ $t("general.cafe.panel") }}

            <a
              class="mt-15"
              :href="`https://queue.qrwaiter.com.ua/login/${cafe.qId}`"
              target="_blank"
              >queue.qrwaiter.com.ua/login/{{ cafe.qId.substring(0, 4) }}..</a
            >
          </h4>

          <!-- v-if="cafe.online_menu_link && readyDelivery.total" -->

          <!-- <div class="sales-boost">
            <a href="#" @click.prevent="sales_boost_modal = true">Як збільшити онлайн продажі в Вашому закладі?</a>
          </div> -->
        </div>
      </div>
      <div class="stats"></div>

      <div class="cafe-card-right c-white" v-if="!editing && false">
        <h5 class="activity-title">Активність</h5>
        <div class="activity-chart">
          <img src="/icons/activity-placeholder.svg" />
        </div>
        <div class="activity-orders row">
          <div class="col-6">
            <h5 class="orders-title">Monthly orders</h5>
            <h1 class="orders-value">1234</h1>
            <p class="orders-subtext">
              <span class="c-lightgreen">4%</span> since last week
            </p>
          </div>
          <div class="col-6">
            <h5 class="orders-title">Monthly orders</h5>
            <h1 class="orders-value">1234</h1>
            <p class="orders-subtext">
              <span class="c-lightgreen">4%</span> since last week
            </p>
          </div>
        </div>
      </div>
    </div>

    <SalesBoostModal
      @close="sales_boost_modal = false"
      v-if="sales_boost_modal"
    />
    <div class="card-tags">
      <button class="card-mode-tag i" v-if="cafe.modes.inside"></button>
      <button class="card-mode-tag p" v-if="cafe.modes.preorder"></button>
      <button class="card-mode-tag d" v-if="cafe.modes.delivery"></button>
      <button class="card-mode-tag r" v-if="cafe.modes.reserve"></button>
    </div>
  </div>
</template>

<script>
import SmallButton from "@/components/SmallButton.vue";
import ImageUploader from "@/components/ImageUploader.vue";

import SalesBoostModal from "@/components/modals/SalesBoostModal.vue";

import moment from "moment";

let gmapAutocomplete = null;

export default {
  data() {
    return {
      editing: false,

      edit_fields: {
        name: null,
        address: null,
        description: null,
        image: null,
        contact_phone: null,
        city: null,
        keywords: null,
        price_level: null,
        online_menu_link: null,
      },

      sales_boost_modal: false,

      lastEdit: Date.now(),
    };
  },
  methods: {
    showEditUI() {
      if (Date.now() - this.lastEdit < 300) {
        return;
      }

      this.editing = true;

      this.edit_fields = {
        name: this.cafe.name,
        address: this.cafe.address,
        description: this.cafe.description,
        image: this.cafe.image,
        contact_phone: this.cafe.contact_phone,
        keywords: this.cafe.keywords,
        price_level: this.cafe.price_level,
        online_menu_link: this.cafe.online_menu_link,
      };

      this.$nextTick(this.showGoogleMapInput);
    },
    showGoogleMapInput() {
      const el = document.getElementById("gmapAddressField");

      const autocomplete = new window.google.maps.places.Autocomplete(el, {
        types: ["geocode"],
      });

      autocomplete.setFields(["formatted_address", "address_component"]);

      autocomplete.setComponentRestrictions({
        country: "ua",
      });

      autocomplete.addListener(
        "place_changed",
        this.onGmapPlaceChange.bind(this)
      );

      gmapAutocomplete = autocomplete;

      if (this.edit_fields.address) {
        el.value = this.edit_fields.address;
      }
    },
    onGmapPlaceChange() {
      if (gmapAutocomplete) {
        const place = gmapAutocomplete.getPlace();

        const components = place.address_components;

        const locality_component = components.find(
          (c) => c.types.includes("locality") || c.types.includes("political")
        );

        this.edit_fields.city = locality_component.long_name || "?";

        this.edit_fields.address = place.formatted_address;
      }
    },
    onImageChange(url) {
      this.edit_fields.image = url;
    },
    hideEditUI() {
      this.lastEdit = Date.now();
      this.editing = false;
    },
    onEditFinish() {
      this.lastEdit = Date.now();

      this.editing = false;
      this.$store.commit("setCafeGeneralData", this.edit_fields);
      this.$store.dispatch("saveCafe");
    },
    goToSettings() {
      this.$router.push("/general");
    },
  },
  components: {
    SmallButton,
    ImageUploader,
    SalesBoostModal,
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    onlineMenuLink() {
      return this.$store.getters.onlineMenuLink("delivery");
    },
    readyDelivery() {
      return this.$store.getters.readyDelivery;
    },
    shouldShowMenuLink() {
      //93 is the ID of last cafe with marketplace only billing
      return (
        this.cafe._id < 93 ||
        this.$store.getters["subscriptions/atleastOneSubscription"]
      );
    },
    todaySchedule() {
      if (!this.cafe.schedule) return null;
      let day = moment().weekday();

      //moment days are 0 indexed from sunday, but we start from monday
      if (day == 6) {
        day = 0;
      } else {
        day++;
      }

      const schedule_item = Object.values(this.cafe.schedule)[day];

      if (!schedule_item) return null;

      if (!schedule_item.workday) return null;

      const fmt = (n) => `${n}`.padStart(2, "0");

      return `${fmt(schedule_item.startHour)}:${fmt(
        schedule_item.startMinute
      )} - ${fmt(schedule_item.endHour)}:${fmt(schedule_item.endMinute)}`;
    },
  },
};
</script>

<style scoped>
.mb-15 {
  margin-bottom: 1.6666666666666667vh;
}
.card-tags {
  display: flex;
  flex-flow: column;
  bottom: 3.2vh;
  position: absolute;
  top: 2.2222vh;
  right: 0;
  z-index: 0;
  overflow: hidden;
}

.card-mode-tag:first-child {
  margin-top: 0;
}

.card-mode-tag {
  height: 1.1111vh;
  width: 3.3333vh;
  border-radius: 1.6666vh 0 0 1.6666vh;
  font-weight: bold;
  margin-bottom: 0.5555vh;
  border: none;
  outline: none;
  border: none;
  outline: none;
  color: #1d1d1d;
}
.text-one-line {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.card-mode-tag.i {
  background: #129b81;
}
.card-mode-tag.d {
  background: #cbd9e6;
}
.card-mode-tag.p {
  background: #ffd2a8;
}

.card-mode-tag.m {
  background: #aeccc6;
}

.card-mode-tag.r {
  background: #aeccc6;
}
.info-text-line {
  display: flex;
  align-items: center;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #908f8d;
  margin-bottom: 1.1111vh;
  padding-right: 6.666666666666667vh;
}
.info-text-line img {
  width: 1.6666vh;
  margin-right: 1.1111vh;
}
.text-line {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
}
.text-line a {
  color: #129b81;
  text-decoration: none;
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
}
.text-line span {
  color: #ededed;
}
span.address {
  font-size: 1.7vh;
  display: block;

  line-height: normal;
}
.cafe-card-container {
  display: flex;
  cursor: pointer;
}

.cafe-card-general {
  display: flex;
  width: 100%;
  height: min-content;
}
.cafe-card-left {
  width: 100%;
}
.lh-0 {
  line-height: 0;
}

.cafe-title-link {
  border-radius: 0.5vh;
  outline: none;
  width: 40%;
  border: none;
  margin-left: 0.5vh;
}

select {
  width: 100%;
  border-radius: 0.5vh;
  border: none;
  margin-top: 1.1vh;
}

.info-name {
  line-height: 0.8;
  font-size: 2.8vh;
}

h4.info-description {
  font-size: 1.7vh;
  line-height: 0.8;
  /* padding-top: 1.1vh; */
  padding-top: 0.5vh;
  line-height: inherit;
}

.card-image {
  width: 45%;
}

.card-image img {
  position: absolute;
  height: 100%;
  width: 45%;
  object-fit: cover;
}

.blur {
  filter: blur(2px);
}

.cafe-image,
.cafe-image-placeholder {
  object-fit: cover;
  border-radius: 1.3333333333333333vh 0 0 1.3333333333333333vh;
}

.general-info {
  width: 55%;
  color: #ededed;
  padding: 2.222vh 3.3333333333333335vh;
}

.general-info a {
  font-size: 1.7vh;
  padding-top: 1.2vh;
}

h2,
h4 {
  margin-bottom: 0;
}

.info-field {
  color: #a4a3a1;
  font-size: 1.7vh;
  display: block;
}

.info-field:first-of-type {
  padding-top: 1vh;
}

.cafe-card-links {
  color: #ededed;
  padding-top: 3.3vh;
  position: relative;
  height: auto;
  font-size: 2vh;
}

.cafe-card-link {
  font-size: 2vh;
}

.queue-link {
  margin-bottom: 2vh;
}

.queue-id {
  color: #129b81;
}

.cafe-card-right {
  width: 50%;
  margin-left: 3vw;
}

.activity-chart {
  height: 17vh;
  width: 100%;
  /* background: white; */
}

.activity-chart img {
  width: 100%;
  max-height: 100%;
}

.activity-orders {
  margin-top: 2vh;
}

.orders-title {
  font-size: 1.2vw;
  font-weight: 100;
}

.orders-value {
  font-size: 3.5vw;
  font-weight: 500;
  margin-bottom: 0;
}

.orders-subtext {
  font-size: 1vw;
  margin-top: 0;
}

.cafe-edit {
  text-align: right;
  cursor: pointer;
}

.w-min {
  width: min-content;
}

.cafe-edit img {
  width: auto;
  height: 3.5vh;
}

.cafe-property-input {
  background: #ededed;
  border-radius: 0.5vh;
  font-family: Roboto;
  font-size: 1.8vh;
  outline: 0;
  border: 0;
  padding: 0.1vh 0.6vh;
  margin-top: 1.1vh;
  width: 100%;
}

.f-input {
  font-size: 2.8vh;
}

.small-input {
  font-size: 1.4vh;
}

.edit-actions {
  text-align: right;
}

.edit-actions img {
  margin-left: 1vh;
  height: 3.5vh;
  width: auto;
}

.edit-actions div {
  display: inline-block;
  cursor: pointer;
}

.cafe-image-uploader {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  width: 100%;
}

.edit-accept {
  margin-left: 0.3vw;
}

.cafe-link-input {
  font-size: 2vh;
  padding: 0.5vh;
  width: 46.9%;
}

.link-details {
  font-size: 1.7vh;
  margin-top: 0.3vh;
}

.sales-boost {
  bottom: 0;
  position: absolute;
  font-size: 2vh;
}
.iqos-no-border {
  border: none;
}
</style>
